var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-pweb',[_c('h2',[_vm._v("Minhas mensagens e notificações")]),_c('p',[_vm._v("Defina suas preferências gerais do seu acesso ao software")]),_c('div',{staticClass:"m-t-lg"},[_vm._v(" Nenhuma mensagem ou notificação disponível. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }